import React from "react";
import Table from "react-bootstrap/Table";
import "./TableData.css";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Dropdown, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { thColor, tbBorderColor, tdColor } from "../ThemeConfig/tableConfig";
import { useTableDynamicStyles } from "../useDynamic/table_DynamicStyle";
import {
  colorViewBtn,
  colorEditBtn,
  colorDeleteBtn,
  iconViewBtn,
  iconEditBtn,
  iconDeleteBtn,
  hoverViewBtn,
  hoverEditBtn,
  hoverDeleteBtn,
} from "../ThemeConfig/btnTableConfig";
import { useButtonTableDynamicStyles } from "../useDynamic/ButtonTable_DynamicStyle";
function TableData(props) {
  useTableDynamicStyles(thColor, tbBorderColor, tdColor);
  useButtonTableDynamicStyles(
    colorViewBtn,
    colorEditBtn,
    colorDeleteBtn,
    iconViewBtn,
    iconEditBtn,
    iconDeleteBtn,
    hoverViewBtn,
    hoverEditBtn,
    hoverDeleteBtn
  );
  const [dataTable, setDataTable] = useState([]);
  const [perms, setPerms] = useState({
    create: false,
    delete: false,
    update: false,
    view: false,
  });
  const navigate = useNavigate();

  const LoadEdit = (id) => {
    navigate((props.editUrl ?? "") + id);
  };
  useEffect(() => {
    if (props.dataTable) {
      setDataTable(props.dataTable);
    }
  }, [props.dataTable]);

  const LoadView = (id) => {
    navigate((props.viewUrl ?? "") + id);
  };

  const [dataPerPage, setDataPerPage] = useState(10);// Number of items to display per page
  const [currentPage, setCurrentPage] = useState(1); // Current page number
  const [currentItems, setCurrentItems] = useState([]); // State for currentItems
  const [currentPagi, setCurrentPagi] = useState([
    {
      id: 0,
      item: 10,
    },
    {
      id: 1,
      item: 25,
    },
    {
      id: 2,
      item: 50,
    },
    {
      id: 3,
      item: 100,
    },
    {
      id: 4,
      item: 200,
    },
    {
      id: 5,
      item: 500,
    },
  ]); // State for currentItems
  // Update currentItems whenever dataTable or currentPage changes
  const [maxData, setMaxData] = useState(props.totalNumber);

  useEffect(() => {
   

    if (dataPerPage > props.totalNumber && currentPage > 1) {
      setCurrentPage(1);
    }
  }, [props.totalNumber]);

  useEffect(() => {
    const indexOfLastItem = currentPage * dataPerPage;
    const indexOfFirstItem = indexOfLastItem - dataPerPage;
    const slicedItems = dataTable.slice(indexOfFirstItem, indexOfLastItem);
    setCurrentItems(slicedItems);
    setPerms((prev) => ({ ...prev, ...props.tablePermission }));
  }, [dataTable, currentPage, dataPerPage]);

  // Change the current page
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    if(props.changePage){
      props.changePage(pageNumber)
    }
  };
  const handleChangeData = (event) => {
    // console.log("event : ", event.target.value);
    setDataPerPage(event.target.value);
    handlePageChange(1)
    if(props.changeDataPerPage){
      props.changeDataPerPage(event.target.value)
    }
  };

  //sort no.
  function sortByDesc(arr, typeSort) {
    if(typeSort === 'desc') {
        return arr.slice().sort((a, b) => b.id - a.id);
    }
    else {
        return arr.slice().sort((a, b) => a.id - b.id);
    }
}
  
  const renderTooltipView = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  const renderTooltipEdit = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Delete
    </Tooltip>
  );
  
  return (
    <>
    <Row>
      <Col xs={10} className="d-flex mt-4">
        <span className="pr-2 align-self-center text-sm ">
            {" "}
            Record :{" "}
        </span>
        <Form.Select className="select-page mr-2" onChange={handleChangeData}>
              {currentPagi.map((dataprops) => (
                <option key={dataprops.id} value={dataprops.item}>
                  {dataprops.item}
                </option>
              ))}
        </Form.Select>
      </Col>
      
    </Row>
    
      <Table responsive="sm" className="mt-3 fontReg font-size03">
        <thead>
          <tr>
            {props.dataHeader?.map((item, idx) => 
          {
            // console.log('props.tableParam header',props.tableParam)
            let isDescSorting = false
            let isAscSorting = false
            let futureSortingOrder = "desc"
            if(props.tableParam){
              isDescSorting = props.tableParam.sorting.column === item.column && props.tableParam.sorting.order === "desc";
              isAscSorting = props.tableParam.sorting.column === item.column && props.tableParam.sorting.order === "asc";
              futureSortingOrder = isDescSorting ? "asc" : "desc";
            }
            if(item.column!='action'){ 
              return (              
                <th key={item.column} style={item.style} onClick={() => props.sortTable({ column : item.column, order: futureSortingOrder })}>
                  {item.label}
                  {isDescSorting && (
                    <span>
                      <img src="assets/icons/sort03.png" alt="" className="ic-sort" />
                    </span>
                  )}
                  {isAscSorting && (
                    <span>
                      <img src="assets/icons/sort02.png" alt="" className="ic-sort" />
                    </span>
                  )}
                  {!isDescSorting && !isAscSorting && (
                    <span>
                      <img src="assets/icons/sort01.png" alt="" className="ic-sort" />
                    </span>
                  )}
                </th>
              )
            }
            else{
              return (
                <th key={idx} style={item.style} >{item.label}</th>
              )
            }
              }
            )}
          </tr>
        </thead>
        
        <tbody>
          <tr className="space-table"></tr>
          {props.dataTable &&
            props.dataTable.map((item, idx) => (
              <>
              <tr key={idx}>
                {Object.keys(item).map((key) => {
                  if (item[key].isHide) {
                    return null;
                  }
                  if (key != "action" && key != "images" && key !== 'resume') {
                    return (
                      <td key={key} style={item[key].style}>
                        <> {item[key].data}</>
                      </td>
                    );
                  }
                  if (key == "images") {
                    return (
                      <td key={key} style={item[key].style}>
                        <img
                          width={"50px"}
                          src={item[key].data}
                          // src={Material1}
                          alt=""
                        />
                      </td>
                    );
                  }
                  if (key === "resume") {
                    return (
                        <td key={key} style={item[key].style}>
                            <a href={item[key].data} target="_blank" rel="noopener noreferrer" className="file-link">
                                {item[key].data}
                            </a>
                        </td>
                    );
                  }
                })}
                <td
                  className={
                    (perms.view === false || item?.action?.view === false) &&
                    // perms.edit === false &&
                    (perms.edit === false || item?.action?.edit === false) &&
                    (perms.update === false ||
                      item?.action?.update === false) &&
                    (perms.delete === false ||
                      item?.action?.delete === false) &&
                    (perms.create === false || item?.action?.create === false)
                      ? "d-none "
                      : ""
                  }
                >
                  <Row className="d-flex justify-content-start align-items-center td-action ">
                    {item?.action?.view || perms.view ? (
                      <Col
                        md={12}
                        lg={4}
                        xl={3}
                        className="d-flex justify-content-center align-items-center mgt-mob"
                      >
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltipView}
                        >
                          <button
                            className={`mx-3 
                              ${maxData > 10 &&
                              window.location.pathname ===
                                "/backoffice/listPayment"
                                ? "btn-view"
                                : "btn-view"}`
                            }
                            onClick={() => {
                              LoadView(item[props.idName].data);
                            }}
                          >
                            <img
                              src="assets/icons/ic-files.png"
                              alt="Login Logo"
                              className="ic-actions"
                            />
                          </button>
                        </OverlayTrigger>
                      </Col>
                    ) : null}
                    {item?.action?.edit || perms.edit ? (
                      <Col
                        md={12}
                        lg={4}
                        xl={3}
                        className="d-flex justify-content-center align-items-center mgt-mob"
                      >

                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltipEdit}
                        >
                          <button
                            className={`mx-3  ${window.location.pathname ===
                              "/backoffice/listPayment"
                                ? " btn-edit"
                                : "btn-edit"}`
                            }
                            onClick={() => {
                              LoadEdit(item[props.idName].data);
                            }}
                          >
                            <img
                              src="assets/icons/edit.png"
                              alt="Login Logo"
                              className="ic-actions"
                            />
                          </button>
                        </OverlayTrigger>
                      </Col>
                    ) : (
                      ""
                    )}
                    {item?.action?.delete || perms.delete ? (
                      <Col
                        md={12}
                        lg={4}
                        xl={3}
                        className={
                          window.location.pathname !==
                            "/backoffice/permission" &&
                          window.location.pathname !== "/backoffice/userAccount"
                            ? "d-flex justify-content-center align-items-center mgt-mob"
                            : "d-none"
                        }
                      >
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltipDelete}
                        >
                          <button
                            className={"btn-remove"}
                            onClick={async () => {
                              await props.removeData(item[props.idName].data,item['role']?.data);
                            }}
                          >
                            <img
                              src="assets/icons/delete.png"
                              alt="Login Logo"
                              className="ic-actions"
                            />
                          </button>
                        </OverlayTrigger>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </td>
              </tr>
              </>
            ))}
        </tbody>
      </Table>
      {/* Pagination component */}
      <div className="d-flex justify-content-between">
        {/* <span> {dataPerPage} records of {props.totalNumber} records</span> */}
        <span> {props.totalNumber} records</span>
        <ul className="pagination"> 
            
          {props.totalNumber > dataPerPage && (//เปลี่ยน dataTable.length เป็น props.totalNumber
          <React.Fragment>
            {Array.from(
              { length: Math.ceil(props.totalNumber / dataPerPage) },
              (_, index) => index + 1
            ).map((pageNumber) => (
              <li
                key={pageNumber}
                className={pageNumber === currentPage ? "active" : ""}
              ></li>
            ))}
            <span className="align-self-center mr-2">
              {Number((dataPerPage*(currentPage-1)))+1} -&nbsp; 
              {Number(dataPerPage*(currentPage-1))+Number(dataPerPage)} of&nbsp;
              {props.totalNumber}
            </span>
            {currentPage > 0 && (
              <li>
                <button
                  disabled={currentPage === 0 || currentPage === 1}
                  className="prev"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  <i className="fa fa-angle-left icon-color"></i>
                  {/* Previous */}
                </button>
              </li>
            )}
            <span className="d-flex align-items-center">{currentPage}</span>
            <li>
              <button
                className="next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={!(currentPage < Math.ceil(props.totalNumber / dataPerPage))}
              >
                {/* Next */}
                <i className="fa fa-angle-right icon-color"></i>
              </button>
            </li>
            <span className="d-flex align-items-center">
              {Math.ceil(props.totalNumber / dataPerPage)}
            </span>
            </React.Fragment>    
          )}
        </ul>
      </div>
      
    </>
  );
}

export default TableData;
